/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Membership_Confirmations_Confirm_Modal_TitleInputs */

const en_admin_membership_confirmations_confirm_modal_title = /** @type {(inputs: Admin_Membership_Confirmations_Confirm_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm Membership`)
};

const nl_admin_membership_confirmations_confirm_modal_title = /** @type {(inputs: Admin_Membership_Confirmations_Confirm_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lidmaatschap bevestigen`)
};

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_Modal_TitleInputs) => LocalizedString} */
const de_admin_membership_confirmations_confirm_modal_title = en_admin_membership_confirmations_confirm_modal_title;

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_Modal_TitleInputs) => LocalizedString} */
const es_admin_membership_confirmations_confirm_modal_title = en_admin_membership_confirmations_confirm_modal_title;

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_Modal_TitleInputs) => LocalizedString} */
const fr_admin_membership_confirmations_confirm_modal_title = en_admin_membership_confirmations_confirm_modal_title;

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_Modal_TitleInputs) => LocalizedString} */
const it_admin_membership_confirmations_confirm_modal_title = en_admin_membership_confirmations_confirm_modal_title;

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_Modal_TitleInputs) => LocalizedString} */
const pt_br2_admin_membership_confirmations_confirm_modal_title = en_admin_membership_confirmations_confirm_modal_title;

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_Modal_TitleInputs) => LocalizedString} */
const pl_admin_membership_confirmations_confirm_modal_title = en_admin_membership_confirmations_confirm_modal_title;

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_Modal_TitleInputs) => LocalizedString} */
const hu_admin_membership_confirmations_confirm_modal_title = en_admin_membership_confirmations_confirm_modal_title;

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_Modal_TitleInputs) => LocalizedString} */
const ro_admin_membership_confirmations_confirm_modal_title = en_admin_membership_confirmations_confirm_modal_title;

/**
* | output |
* | --- |
* | "Confirm Membership" |
*
* @param {Admin_Membership_Confirmations_Confirm_Modal_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_membership_confirmations_confirm_modal_title = /** @type {((inputs?: Admin_Membership_Confirmations_Confirm_Modal_TitleInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Membership_Confirmations_Confirm_Modal_TitleInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_membership_confirmations_confirm_modal_title(inputs)
	if (locale === "de") return de_admin_membership_confirmations_confirm_modal_title(inputs)
	if (locale === "es") return es_admin_membership_confirmations_confirm_modal_title(inputs)
	if (locale === "fr") return fr_admin_membership_confirmations_confirm_modal_title(inputs)
	if (locale === "nl") return nl_admin_membership_confirmations_confirm_modal_title(inputs)
	if (locale === "it") return it_admin_membership_confirmations_confirm_modal_title(inputs)
	if (locale === "pt-BR") return pt_br2_admin_membership_confirmations_confirm_modal_title(inputs)
	if (locale === "pl") return pl_admin_membership_confirmations_confirm_modal_title(inputs)
	if (locale === "hu") return hu_admin_membership_confirmations_confirm_modal_title(inputs)
	return ro_admin_membership_confirmations_confirm_modal_title(inputs)
});
export { admin_membership_confirmations_confirm_modal_title as "admin.membership_confirmations.confirm_modal_title" }